import React, { useRef, useState, useEffect } from 'react';

const CounterCard = ({ value, label }) => {
  const cardRef = useRef(null);
  const [prevValue, setPrevValue] = useState(value);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    if (value !== prevValue) {
      setPulse(true);
      setPrevValue(value);
      const timer = setTimeout(() => setPulse(false), 300);
      return () => clearTimeout(timer);
    }
  }, [value, prevValue]);

  // High-performance direct DOM manipulation (zero React re-renders on mousemove)
  const handlePointerMove = (e) => {
    const el = cardRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const normX = (x / rect.width - 0.5) * 2;
    const normY = (y / rect.height - 0.5) * 2;

    el.style.transform = `perspective(600px) rotateX(${(-normY * 9).toFixed(2)}deg) rotateY(${(normX * 9).toFixed(2)}deg) translateY(-4px)`;
  };

  const handlePointerLeave = () => {
    const el = cardRef.current;
    if (!el) return;
    el.style.transform = 'perspective(600px) rotateX(0deg) rotateY(0deg) translateY(0px)';
  };

  return (
    <div
      ref={cardRef}
      className="counter-item counter-box-3d"
      onPointerMove={handlePointerMove}
      onPointerLeave={handlePointerLeave}
    >
      <div className="counter-card-silver-rim" aria-hidden="true" />
      <div className="counter-card-inner">
        <div className={`counter-value ${pulse ? 'num-flip' : ''}`}>
          <span className="digit-span">{String(value).padStart(2, '0')}</span>
        </div>
        <div className="counter-label">{label}</div>
      </div>
    </div>
  );
};

export default CounterCard;
